import { type Config, defaultConfig } from "library/defaultConfig"

/**
 * The transition names that can be used in the page transition
 */
export type TransitionNames = "slide"

const config: Config = {
	...defaultConfig,
	defaultTransition: "slide",
}

export default config
